var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h3',{staticClass:"title is-3"},[_vm._v("Tidak ada absensi untuk hari ini. Untuk link first timer silahkan gunakan link di bawah ini :")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/new_people"}},[_vm._v("Link First Timer")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb8a607","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NoAbsent.vue
// module id = null
// module chunks = 